export const DEFAULT_SKU_IMAGE =
  'https://instore.vteximg.com.br/assets/vtex.instore/files/noimage___9acee2c5847f6e2d26fdfc6193722c83.svg'
